import React from 'react';
import Grid from '@material-ui/core/Grid';

import { LogType } from '../utils';

import Label from './Label';
import Value from './Value';

/**
 * @param {Object} props
 * @param {(string|number)} props.value
 * @param {string} [props.label]
 * @param {boolean} [props.split]
 * @param {('text'|'date'|'percentage'|'currency'|'phone')} [props.type='text']
 */
const ChangeLogLabelValue = ({ value, label, split, type = 'text' }) => (
  <Grid container direction={type === LogType.Html ? 'column' : 'row'}>
    <Label label={label} split={split} />
    <Value type={type} value={value} />
  </Grid>
);

export default ChangeLogLabelValue;
